import React from "react";
import PropTypes from "prop-types";
import { Tooltip } from "react-tooltip";
import moment from "moment";

const EnergyChartTooltip = props => {
  const actual = `${
    typeof props.actual === "number" ? props.actual.toFixed(2) : "--"
  }${props.unit}`;

  const delta = !isNaN(props.delta)
    ? (props.delta > 0 ? "+" : "") + props.delta + "%"
    : "";

  return (
    <Tooltip
      id={props.id}
      className="cb-c-energy-chart__tooltip"
      type="light"
    >
      <span>{moment(props.time).format("HH:mm")}</span>
      <br />
      <span className="fable:text-sm fable:font-mono">{actual}</span>
      <br />
      <span>{delta}</span>
    </Tooltip>
  );
};

EnergyChartTooltip.propTypes = {
  id: PropTypes.string.isRequired,
  time: PropTypes.instanceOf(Date),
  actual: PropTypes.number,
  delta: PropTypes.number
};

export default EnergyChartTooltip;
